import { render } from "./LoaderPopup.vue?vue&type=template&id=1d87943b&scoped=true&ts=true"
import script from "./LoaderPopup.vue?vue&type=script&lang=ts"
export * from "./LoaderPopup.vue?vue&type=script&lang=ts"

import "./LoaderPopup.vue?vue&type=style&index=0&id=1d87943b&scoped=true&lang=scss"

import exportComponent from "D:\\a\\1\\s\\mobileApp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d87943b"]])

export default __exports__